import { LightVisualizer } from './LightVisualizer.js';
import { vector_3 } from '../../../utility/Conversion.js';
import { Vector3 as BABYLON_Vector3 } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.vector.js';
import { LightPositionSphere } from './PositionSphere.js';
import { IVector3 } from '../../../../api.js';
export class PointLightVisualizer extends LightVisualizer {
    constructor(light, line_manager, color_mode, scene) {
        super(light, line_manager, color_mode, scene);
        this._minimum_line_length = 0;
        this._position_sphere = new LightPositionSphere('PointLight', scene);
        this.update();
    }
    update() {
        super.update_visualizer();
        const position = vector_3(this._light.get_world_position());
        this.draw_outer_bounds(position);
        this._position_sphere.update(position, this._line_color);
    }
    dispose(start_index = 0) {
        this._position_sphere.dispose();
        super.dispose(start_index);
    }
    draw_outer_bounds(position) {
        // Used to remove incorrect curve from first draw call, due to too early
        // light.get_world_position call
        this.remove_lines(0);
        const rotation_axes = [BABYLON_Vector3.Up(), BABYLON_Vector3.Right(), BABYLON_Vector3.Backward()];
        let line_index = 0;
        rotation_axes.forEach(axis => {
            const start_point = vector_3(IVector3.perpendicular(axis))
                .scale(this._light_range)
                .add(position);
            line_index += this.draw_curve(line_index, start_point, start_point, axis, position, Math.PI * 2);
        });
    }
}
//# sourceMappingURL=PointLightVisualizer.js.map